import { RichText } from '../atoms/RichText';
import { ImageBlock, ImageBlockProps } from '../molecules/ImageBlock';
import { Title } from '../atoms/Title';
import { SimpleReactComponentProps } from '../../../types/components';
import { useDOMPurify } from '../../../lib/useDOMPurify';
import { LinkComponent } from '../molecules/LinkComponent';

export interface PromoBlockProps extends SimpleReactComponentProps {
	title: string;
	url?: string;
	image?: ImageBlockProps;
	content?: string;
}

const contentCardBlockClassNames =
	'flex flex-col justify-center rounded-t-lg mt-0 overflow-hidden scroll-mt-[84px]';
const imageClassOverrides = 'w-full aspect-[16/9] object-cover rounded-lg';
const titleClassNames =
	'pt-[16px] pb-[10px] text-md text-primary text-lg font-bold underline';
const summaryClassNames = 'pb-[10px] text-base text-primary';

export const PromoBlock = ({
	title,
	url,
	image,
	content,
	classOverrides,
	anchorId,
}: PromoBlockProps) => {
	const sanitizedContent = useDOMPurify(content || '');
	return (
		<section className={contentCardBlockClassNames} id={anchorId?.value}>
			{image?.src && (
				<ImageBlock
					{...image}
					classOverrides={classOverrides || imageClassOverrides}
				/>
			)}
			<LinkComponent url={url}>
				<Title style="h3" title={title} classOverrides={titleClassNames} />
			</LinkComponent>
			{content && (
				<RichText richText={sanitizedContent} className={summaryClassNames} />
			)}
		</section>
	);
};
